import Vue from 'vue'
import './style/normalize.css'
import 'lib-flexible';
import App from './app.vue'
import { Toast,  Form, Field, Button, List, Skeleton, Cell } from 'vant'
import routes from './route'
import Router from 'vue-router'
import axios from './util/axios'
import i18n from './i18n'

Vue.use(Router)
Vue.use(Toast)
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(List)
Vue.use(Skeleton)
Vue.use(Cell)
Vue.use(i18n)
Vue.prototype.axios = axios;

const router = new Router({
    mode : 'history',
    routes
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

